import { Constants } from '@spectorasoftware/homegauge-vue';

import AuthorizationUtility from '@/utilities/authorization-utility';

const serviceErrorHandler = apiError => {
  if (!apiError) {
    return;
  }

  const isUnauthorizedError = apiError.status === Constants.HttpStatusCodes.Unauthorized;
  if (isUnauthorizedError) {
    AuthorizationUtility.redirectToAuthorize(true);
  }
};

export default serviceErrorHandler;
